import * as React from "react"

function SvgChecboxUncheck(props) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <rect x={0.5} y={0.5} width={17} height={17} rx={2.5} stroke="#AAA" />
    </svg>
  )
}

export default SvgChecboxUncheck
